import WebsiteModal from "modal/WebsiteModal";
import {svg_include} from "base/functions";
import Gallery from "webPage/Gallery";
import Track from "util/Track";

export default class GalleryModal extends WebsiteModal {

    constructor($element, settings = {}) {
        super({
            close: {
                background: false,
                button: true,
                escape: false,
            },
        });

        this.$element = $element;
        this.data = null;

        try {
            this.data = JSON.parse(this.$element.find('.js-modal-images').text());
        } catch (e) {
            console.log('Could not load images', e);
        }
    }

    bindEvents() {
        super.bindEvents();

        this.gallery = new Gallery(this.$modal.find('.js-image-gallery'), {
            itemClass: "image-gallery__main-image",
            pipClass: "image-gallery__thumbnail",
            navigateClass: "js-navigate",
            pipsClass: "js-pips",
            itemsClass: "js-items",
            animationDuration: 300,
        });

        this.track = new Track(this.$modal.find('.js-image-gallery-wrap'));
    }

    setActive(index) {
        if (this.gallery) {
            if (this.gallery.getActiveIndex() === parseInt(index)) {
                return;
            }
            this.gallery.showItem(parseInt(index));
        }
    }

    updateTrackOffset(to = null) {
        if (to === null) {
            to = this.gallery.getActiveIndex();
        }
        let $to = this.track.getItems().eq(to);

        let offsetLeft = $to.position().left;
        let offsetRight = offsetLeft + $to.outerWidth() + 10;

        if (offsetLeft < this.track.getTransform()) {
            this.track.setTransform(offsetLeft - 0);
            return;
        }

        if (offsetRight > this.track.getTransform() + this.$modal.find('.js-image-gallery-wrap').innerWidth()) {
            this.track.setTransform(offsetRight - this.$modal.find('.js-image-gallery-wrap').innerWidth() + 10);
            return;
        }
    }

    buildThumbnails() {
        return (
            eotwJSXFactory('div', {className: "image-gallery__thumbnails track js-image-gallery-wrap"}, [
                eotwJSXFactory('div', {className: "track__inner-wrap js-pips js-outer-wrap"}, [
                    eotwJSXFactory('div', {className: "track__track js-track"}, [
                        Object.keys(this.data).map((key) => {
                            return this.buildThumbnail(this.data[key]);
                        })
                    ])
                ])
            ])
        )
    }

    buildThumbnail(data) {
        return (
            eotwJSXFactory('button', {type: "button", className: "image-gallery__thumbnail js-track-item js-view-image"}, [
                this.buildImage(data['thumbnail'])
            ])
        );
    }

    buildMainImage(data, key) {
        return eotwJSXFactory('div', {'data-index': key, className: 'image-gallery__main-image' + (key === '0' ? ' image-gallery__main-image--active' : '')}, [
            this.buildImage(data['main-image'])
        ]);
    }

    buildImage(data) {
        return eotwJSXFactory('picture', null, [
            Object.keys(data.sizes).map((key) => {
                return eotwJSXFactory('source', {media: `(${key})`, srcSet: `${data.sizes[key]['1x']}, ${data.sizes[key]['2x']} 2x`})
            }),
            eotwJSXFactory('img', {src: data.default['1x'], srcSet: `${data.default['1x']}, ${data.default['2x']} 2x`})
        ]);
    }

    /**
     * @abstract
     */
    buildElement() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal"}, [
                eotwJSXFactory('button', {type: "button", className: "close-btn js-close-modal"}),
                eotwJSXFactory('div', {className: "image-gallery js-image-gallery"}, [
                    eotwJSXFactory('div', {className: "image-gallery__overlay js-close-modal"}),
                    eotwJSXFactory('div', {className: "image-gallery__main"}, [
                        eotwJSXFactory('div', {className: "image-gallery__main-wrap js-items"}, [
                            Object.keys(this.data).map((key) => {
                                return this.buildMainImage(this.data[key], key);
                            })
                        ])
                    ]),
                    eotwJSXFactory('div', {className: "image-gallery__controls"}, [
                        eotwJSXFactory('button', {type: "button", 'data-direction': "backwards", className: "image-gallery__btn image-gallery__btn--prev js-navigate"}, [
                            eotwJSXFactory('span', {className: "icon", unsafeHtml: svg_include('button-arrow-white')})
                        ]),
                        eotwJSXFactory('button', {type: "button", 'data-direction': "forwards", className: "image-gallery__btn js-navigate"}, [
                            eotwJSXFactory('span', {className: "icon", unsafeHtml: svg_include('button-arrow-white')})
                        ])
                    ])
                ])
            ])
        );
    }
}
